export default "__VITE_ASSET__DeqYcYmL__"